import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { MessengerService } from '@services/messenger/messenger.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthenticationGuard  {

  constructor(private messengerService: MessengerService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.messengerService.getSessionLevel() > 0) {
      return true;
    }

    setTimeout(() => {
      const params = { replaceUrl: true };
      if (!environment.production) {
        params['queryParams'] = { returnUrl: state.url };
      }
      this.router.navigate([{ outlets: { auth: ['auth'] } }], params);
    }, 0);
    return false;
  }
}
